import checkIsConnectedToStripe from '@dashboard/services/seller/checkIsConnectedToStripe';

export default function getShouldSyncSubscription(page = {}, seller = {}) {
  // if the seller is not connected to stripe, we should not sync
  if (!checkIsConnectedToStripe(seller)) {
    return false;
  }

  // if the product is not a subscription, we should not sync
  if (page.product.type !== 'subscription') {
    return false;
  }

  if (!page.product.planActive) {
    return true;
  }

  // if any variant option does not have a stripePriceId or stripeProductId then we should sync
  const shouldSyncVariants = page.product.variants.some(variant => {
    return variant.options.some(option => {
      if (!option.additionalChargeAmount) {
        return false;
      }

      if (option.type !== 'recurring') {
        return false;
      }

      return !option.stripePriceId || !option.stripeProductId;
    });
  });

  if (shouldSyncVariants) {
    return true;
  }

  return false;
}
